import { CreditCardType } from '../services/credit-cards/models';
import { useIntl } from 'react-intl';

// this hook is used to get localized credit card title

export const useCreditCardTitle = () => {
  const intl = useIntl();

  /**
   * The function returns the title of a credit card based on its type, or a default title if the type
   * is not recognized.
   * @param {CreditCardType} type - Credit card type, which is an enum with possible values of Visa,
   * MasterCard, Amex.
   * @returns The function `getCreditCardTitle` returns a string that represents the title of a credit
   * card based on its type. If the type is Visa, MasterCard, or Amex, the corresponding title is
   * returned by formatting a message using the `intl` object. If the type is not recognized, a default
   * title is returned.
   */
  const getCreditCardTitle = (type: CreditCardType) => {
    if (type === CreditCardType.Visa)
      return intl.formatMessage({
        id: 'my_credit_cards.supported_cards.visa',
      });
    else if (type === CreditCardType.MasterCard)
      return intl.formatMessage({
        id: 'my_credit_cards.supported_cards.master_card',
      });
    else if (type === CreditCardType.Amex)
      return intl.formatMessage({
        id: 'my_credit_cards.supported_cards.american_express',
      });
    else if (type === CreditCardType.Mada)
      return intl.formatMessage({
        id: 'my_credit_cards.supported_cards.mada',
      });
    else
      return intl.formatMessage({
        id: 'alt.credit_card_icon',
      });
  };

  return { getCreditCardTitle };
};
